import { render, staticRenderFns } from "./assets-approvel.vue?vue&type=template&id=2a82bb04"
import script from "./assets-approvel.vue?vue&type=script&lang=js"
export * from "./assets-approvel.vue?vue&type=script&lang=js"
import style0 from "./assets-approvel.vue?vue&type=style&index=0&id=2a82bb04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports